import { ModelBase } from "../abstract/model-base.model";
import { Authorization } from "./authorization.model";
import { Profile } from "./profile.model";
import { AuthorizationEntity } from "../../components/authorizations/authorizations-manager/authorizations-manager.component";

export class CustomProfile extends ModelBase implements AuthorizationEntity {

    static override CLASS_NAME: string = 'CustomProfile';

    private _authorizations!: Authorization[];
    private _description!: string;
    private _label!: string;
    private _requiresMfa!: boolean;
    private _userCount!: number;
    private _backup!: CustomProfile;

    public get authorizations(): Authorization[] {
        return this._authorizations;
    }

    public set authorizations(value: any[]) {
        this._authorizations = [];
        for (let i = 0; i < value.length; i++) {
            this._authorizations.push(new Authorization(value[i]));
        }
    }

    public get description(): string {
        return this._description;
    }

    public set description(value: string) {
        this._setValue('_description', value, 'string');
    }

    public get label(): string {
        return this._label;
    }

    public set label(value: string) {
        this._setValue('_label', value, 'string');
    }

    public get requiresMfa(): boolean {
        return this._requiresMfa;
    }

    public set requiresMfa(value: any) {
        this._setValue('_requiresMfa', value, 'boolean');
    }

    public get userCount(): number {
        return this._userCount;
    }

    public set userCount(value: number) {
        this._setValue('_userCount', value, 'integer');
    }

    /*----------------------------------------------------------------------------------------
     * Méthodes AuthorizationEntity
     ----------------------------------------------------------------------------------------*/

    public addAuthorization(code: string): void {
        if (!this._authorizations) {
            this._authorizations = [];
        }

        const existingIndex = this._authorizations.findIndex(auth => auth.code === code);
        if (existingIndex === -1) {
            const newAuth = new Authorization({code: code});
            this._authorizations.push(newAuth);
        }
    }

    public addCustomProfile(customProfile: CustomProfile): void {
        this.authorizations = customProfile.authorizations;
    }

    public addProfile(profile: Profile): void {
        this.authorizations = profile.authorizations;
    }

    public backup(): CustomProfile {
        this._backup = CustomProfile.init();
        this._backup.id = this.id;
        this._backup.label = this.label;
        this._backup.description = this.description;
        this._backup.authorizations = this.authorizations ? [...this.authorizations] : [];
        return this._backup;
    }

    public hasAuthorization(code: string): boolean {
        if (!this._authorizations) {
            return false;
        }
        return this._authorizations.some(auth => auth.code === code);
    }

    public removeAllAuthorizations(): void {
        this._authorizations = [];
    }

    public removeAuthorization(code: string): void {
        if (!this._authorizations) {
            return;
        }

        const index = this._authorizations.findIndex(auth => auth.code === code);
        if (index !== -1) {
            this._authorizations.splice(index, 1);
        }
    }

    public restore(): void {
        if (!this._backup) {
            return;
        }

        this.id = this._backup.id;
        this.label = this._backup.label;
        this.description = this._backup.description;
        this.authorizations = this._backup.authorizations ? [...this._backup.authorizations] : [];
    }
}
